import * as React from "react";
import IconTextButton from "../../../../components/iconTextButton/IconTextButton";


const UsageMaintenanceMatchingWorksToolbar = ({
    handleShowSearchFieldsAndResults,
    isShowSearchFieldsAndResults
}) => {

    return (
        <div className='row' >
            <div style={{ background: '#f5f5f5', width: '98%', margin: '16px', padding: '7px' }}>
                <div className="UsageMaintenanceMatchingWorksToolbar">
                    <div className="toolbarWrapper">
                        <div className="toolbarButton" >
                            <div className="toolbarButtonContainer">
                                <IconTextButton
                                    text={!isShowSearchFieldsAndResults ? "Open Search License To Match" : "Close Search License To Match"}
                                    icon={"icon ms-Icon ms-Icon--Search"}
                                    onClick={() => {handleShowSearchFieldsAndResults()}}
                                    disabled={false}
                                 />
                            </div>
                        </div>
                    </div>
            </div>
            </div>
        </div>
    )
}

export default UsageMaintenanceMatchingWorksToolbar;
